<mat-button #filterButton type="button" #t="matMenuTrigger" [matMenuTriggerFor]="menu" class="filter-button"
    (menuOpened)="handleOpenFilter()" menuOpen="isOpen" #menuTrigger="matMenuTrigger">
    <mat-icon class="filter-icon"  [ngStyle]="{ color: filterIconColor }">filter_list</mat-icon>
</mat-button>
<mat-menu [hasBackdrop]="true" #menu="matMenu" class="filter-menu-panel" overlapTrigger>
    <div class="kt-portlet filter-wrapper"  [ngClass]="{'dark-background': isDarkBackground}" (click)="$event.stopPropagation()">
        <div class="kt-form" [ngStyle]="containerStyles">
            <div cdkDragHandle class="kt-portlet__head kt-portlet__head__custom header-container" *ngIf="filterTitle">
                <div class="kt-portlet__head-label">
                    <h3 class="kt-portlet__head-title">{{filterTitle}}</h3>
                </div>
            </div>
            <div class="filter-body">
                <!-- <div class="kt-portlet__body options-wrapper nav-option-wrapper">
                    <div class="filter-nav-option-container" *ngIf="!loading">
                        <div *ngFor="let segment of segmentControlOptions"
                            (click)="$event.stopPropagation(); onSegmentChange(segment)" class="segment"
                            [ngStyle]="segmentStyles"
                            [ngClass]="selectedSegment?.id==segment.id? 'activeSegment':''">
                            {{segment.label}}
                        </div>
                    </div>
                </div> -->
                <!-- <mat-divider [vertical]="true" class="divider"></mat-divider> -->
                <div class="kt-portlet__body options-wrapper">
                    <div *ngIf="showSapFieldFilter; else noFilterTemplate" class="filter-options-container">
                        <div class="searchBar custom-form-field" *ngIf="!loading">
                            <mat-form-field>
                                <input matInput placeholder="Search" (keyup)="$event.stopPropagation();search($event)"
                                    [(ngModel)]="searchValue" />
                            </mat-form-field>
                        </div>
                        <div class="options-container" *ngIf="!loading && selectedSegment?.type !== 'single-select'">
                            <div *ngIf="selectedSegment?.selectAllOption" class="filter-option" (click)="onSelectAllOption(option)" [ngStyle]="optionStyles">
                                <mat-checkbox name="subtype" [checked]="areAllOptionsSelected()" class="checkbox-containe custom-checkbox" (click)="$event.preventDefault()">{{selectedSegment?.selectAllOption.label}}</mat-checkbox>
                            </div>
                            <div *ngFor="let option of segmentSeperatedFilterOptions| keyvalue" class="filter-option" (click)="onFilterOptionSelect(option)" [ngStyle]="optionStyles">
                                <mat-checkbox name="subtype" [checked]="isOptionSelected(option)" class="checkbox-container custom-checkbox" (click)="$event.preventDefault()" >{{option.value.label}}</mat-checkbox>
                            </div>
                            <div *ngIf="!segmentSeperatedFilterOptions?.length">No Filter Options Found</div>
                        </div>
                        <div class="options-container" *ngIf="!loading && selectedSegment?.type == 'single-select'" >
                            <div *ngFor="let option of segmentSeperatedFilterOptions| keyvalue" class="filter-option" (click)="onFilterOptionSelect(option)" [ngClass]="{'selected': isOptionSelected(option)}" [ngStyle]="optionStyles">
                                {{option.value.label}}
                            </div>
                            <div *ngIf="!segmentSeperatedFilterOptions?.length">No Filter Options Found</div>
                        </div>
                        <div class="loader" *ngIf="loading">
                            <span>Loading...</span>
                            <mat-spinner class="adScreenSpinner" diameter="20"></mat-spinner>
                        </div>
                    </div>
                    <ng-template #noFilterTemplate>
                        <div class="filter-options-container">
                            <kt-sap-filter (filterChanged)="onFilterValidityChange($event)" (onFilterApply)="onApplyFilters($event)"></kt-sap-filter>
                        </div>
                    </ng-template>
                </div>
            </div>
            <div class="kt-portlet__foot  text-right">
                <div class="action-container kt-form__actions">
                    <button mat-raised-button (click)="onCancel()">Cancel</button>&nbsp;
                    <button mat-raised-button color="primary" cdkFocusInitial [disabled]="isResetApplyButtonDisabled()" class="primary-apply-button" [ngStyle]="isResetApplyButtonDisabled() ? primaryButtonStyles : {}"
                        (click)="onFilterChange()">Apply</button>
                </div>
            </div>
        </div>
    </div>
</mat-menu>